// pages/sizeHints.js
// Supplier listings: "Sold by" (the size) vs what the supplier wrote. Wrong
// sizes came from the form pre-selecting the first size ("10kg"); 2026-10-29
// fix — no default, sizes grouped, and these hints. Hints only WARN (supplier
// form before saving, "⚠ check size" in Admin → Supply); nothing is blocked
// or changed. Sizes themselves stay admin-managed (Admin → Market → ⚖ Sizes).

// Things sold whole — one is a "piece", whatever it holds.
const ITEM_WORDS = /\b(drinkers?|feeders?|trays?|lamps?|nipples?|buckets?|basins?|cages?|jerrycans?|containers?)\b/i;

// Weights/volumes written in a name or notes, e.g. "1kg", "100g", "3Ltr", "Packed in 1.5 litres".
const AMOUNT = /(\d+(?:[.,]\d+)?)\s*(kgs?|kilos?|kilograms?|g|gms?|grams?|mls?|l|lts?|ltrs?|litres?|liters?)\b/gi;

function toBase(n, u) {
  const unit = u.toLowerCase();
  if (/^(kgs?|kilos?|kilograms?)$/.test(unit)) return { baseUnit: 'kg', qty: n };
  if (/^(g|gms?|grams?)$/.test(unit)) return { baseUnit: 'kg', qty: n / 1000 };
  if (/^mls?$/.test(unit)) return { baseUnit: 'litre', qty: n / 1000 };
  return { baseUnit: 'litre', qty: n };
}

export function amountsIn(text) {
  const out = [];
  for (const m of String(text || '').matchAll(AMOUNT)) {
    const n = Number(m[1].replace(',', '.'));
    if (n > 0) out.push({ text: m[0].trim(), ...toBase(n, m[2]) });
  }
  return out;
}

// unit: { name, baseUnit, baseQty } — the chosen size. Returns plain-language warnings ([] = looks fine).
export function sizeWarnings({ productName, notes, unit }) {
  if (!unit?.name) return [];
  const base = String(unit.baseUnit || '').toLowerCase();
  const qty = Number(unit.baseQty) || 0;
  const name = String(productName || '');
  const out = [];
  if (ITEM_WORDS.test(name) && base !== 'piece') {
    out.push(`“${name.trim()}” sounds like something sold whole — choose “piece” and give the price for one, not per ${unit.name}.`);
  }
  if (base === 'kg' || base === 'litre') {
    const seen = new Set();
    for (const a of [...amountsIn(name), ...amountsIn(notes)]) {
      if (seen.has(a.text.toLowerCase())) continue;
      seen.add(a.text.toLowerCase());
      if (a.baseUnit !== base) {
        out.push(`You wrote “${a.text}” but chose ${unit.name} (counted in ${base}) — check the size.`);
      } else if (Math.abs(a.qty - qty) > 1e-9) {
        out.push(`You chose ${unit.name} but wrote “${a.text}” — is your price really per ${unit.name}? If you sell ${a.text} packs, choose the matching size (or “piece” for one pack).`);
      }
    }
  }
  return [...new Set(out)];
}

// Sizes for the "Sold by" dropdown: one item / loose amount first, then packs and bags (smallest first).
export function groupUnits(units = []) {
  const single = units.filter(u => Number(u.baseQty) === 1);
  const packs = units.filter(u => Number(u.baseQty) !== 1)
    .sort((a, b) => String(a.baseUnit).localeCompare(String(b.baseUnit)) || Number(a.baseQty) - Number(b.baseQty));
  return { single, packs };
}

export const SIZE_HINT = 'Drinker, feeder, lamp, tray → piece. Sold by weight → kg. A sealed 25 kg bag → 25kg.';
